.janeGoldCallout:empty {
  display: none;
}
